import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, EditableToken, RichTextContent } from '@vibesites/runtime/react';
import { InnerPageHeroSubtitle } from './shared/InnerPageHeroSubtitle';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Featured floor plan banner',
    },
  },
};

export function FeaturedFloorPlanHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="featuredfloorplanhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Featured floor plan banner"
    >
      <InnerPageHeroSubtitle path="featuredfloorplanhero.subtitle" />
      <RichTextContent
        path="featuredfloorplanhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableToken
        path="featuredfloorplanhero.subtitle"
        type="richtext"
        as="span"
        className="hidden"
        style={{ display: 'none' }}
      >
        {''}
      </EditableToken>
      <EditableSlotGroup
        groupPath="featuredfloorplanhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'FeaturedFloorPlanHero',
  displayName: 'Featured Floor Plan Hero',
  tokens: {
    'featuredfloorplanhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Featured Floor Plan</p>',
    },
    'featuredfloorplanhero.subtitle': {
      label: 'Subtitle',
      type: 'richtext',
      defaultValue:
        '<p>A Standout Layout at <span data-type="field-token" data-field="property_name"></span> in <span data-type="field-token" data-field="property_address_city"></span>, <span data-type="field-token" data-field="property_address_state"></span></p>',
    },
  },
  slotGroups: {
    'featuredfloorplanhero.bg_image': bgImageDef,
  },
};

(FeaturedFloorPlanHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default FeaturedFloorPlanHero;
